import { convert as converter } from 'jcampconverter';
import { fromJSON } from "../chromatogram.js";
/**
 * Creates a new Chromatogram from a JCAMP string.
 * @param jcamp - String containing the JCAMP data
 */
export function fromJcamp(jcamp) {
    const data = converter(jcamp, { chromatogram: true }).flatten[0].chromatogram;
    return fromJSON(data);
}
//# sourceMappingURL=jcamp.js.map